import { ACTIONS, MUTATIONS, GETTERS } from "./types";
import axios from "axios";

const actions = {
    [ACTIONS.RETRIEVE_APPLICATIONS]() {
        return axios.get('/api/applications');
    },
    [ACTIONS.RETRIEVE_CATALOG]({ commit, state }) {
        return axios.get('/api/catalog')
            .then(({ data }) => commit(MUTATIONS.SET_CATALOG, data));
    },
    [ACTIONS.SAVE_CONSULT]({ commit, state, getters }) {
        return axios
            .post("/api/leads/save", getters[GETTERS.GET_CONSULT])
            .then(({ data }) => {
                commit(MUTATIONS.SET_CONSULT_ID, data.leadId);
                commit(MUTATIONS.SET_PRODUCTS, data.productsInfo);
            });
    },
    async [ACTIONS.SEND_EMAIL]({ commit, state }, payload) {
        commit(MUTATIONS.SET_LOADING_TO_TRUE);
        return axios
            .post("/api/send-resume-email", {
                email: payload,
                consult_id: state.consult_id
            });
    }
};

export default actions;
